function addCompanyDialogDirective () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/add-company/add-company-dialog.html?$$REVISION$$'
  }
}

export { addCompanyDialogDirective }
